import { perseusSDK } from '../../../__lib__/perseus/sdk'
import type {
  AnalyticsEventName,
  AnalyticsVendor,
  PickAnalyticsEventAttributes,
} from '../../../types'
import { eventFactoryCollection } from '../event-factory'
import { serviceConsentCategory } from '@/tools/cookies-blocker/service/constants'
import type { CookieCategory } from '@/tools/cookies-blocker/types'

export class Perseus implements AnalyticsVendor {
  public name = 'Perseus'
  public consentCategory: CookieCategory = serviceConsentCategory.perseus
  public isInitialized = false

  public async init() {
    await this.lazyLoadModule()
    perseusSDK.init()
    this.isInitialized = true
  }

  private lazyLoadModule = () => Promise.resolve()

  public canHandle = (eventName: AnalyticsEventName) =>
    Object.keys(eventFactoryCollection).includes(eventName)

  public trackEvent<EVENT_NAME extends AnalyticsEventName>(
    eventName: EVENT_NAME,
    attributes: PickAnalyticsEventAttributes<EVENT_NAME>
  ) {
    const factoryMethod = eventFactoryCollection[eventName as keyof typeof eventFactoryCollection]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const eventInstance = factoryMethod(attributes as any)
    perseusSDK.track(eventInstance)
  }
}
